import { render, staticRenderFns } from "./downloadResource.vue?vue&type=template&id=26167784&scoped=true"
import script from "./downloadResource.vue?vue&type=script&lang=js"
export * from "./downloadResource.vue?vue&type=script&lang=js"
import style0 from "./downloadResource.vue?vue&type=style&index=0&id=26167784&prod&scoped=true&lang=css"
import style1 from "./downloadResource.vue?vue&type=style&index=1&id=26167784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26167784",
  null
  
)

export default component.exports